const FOOD_CATEGORY = 'FOOD_CATEGORY';

export const getFoodCategoryFromStorage = () : number => {
    const categoryId = window.localStorage.getItem(FOOD_CATEGORY);
    return Number(categoryId) || -1;
};

export const setFoodCategoryToStorage = (categoryId: number) => {
    window.localStorage.setItem(FOOD_CATEGORY, categoryId.toString());
};